import { DisconnectOutlined, ExportOutlined } from "@ant-design/icons";
import { Button, Grid, message } from "antd";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
// import styles from "./style/SocialMedia.module.css"; // Import CSS module
import { FileImageOutlined, PlusOutlined } from "@ant-design/icons";
import log from "cslog";
import { useItemsFine, useDeleteItemMutation } from "../_actions/app/items";
import { usePostOnInstagram } from "../_actions/social";
import { useCurrentUser } from "../actions/auth";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { ShareAltOutlined } from "@ant-design/icons";
import SocialPostButton from "./SocialPostButton";
import styles from "./style/SocialAccounts.module.css";
import { getImageFileURL, getPublicImageURL } from "../_helpers/image";

const { useBreakpoint } = Grid;

export default function SocialAccounts({ trigger }) {
    const { isLoading, isSuccess, data: dataMe } = useCurrentUser();
    const screens = useBreakpoint();
    const isMobile = !screens.sm;

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const status = searchParams.get("status");
    const msg = searchParams.get("msg");

    const selected_org = dataMe?.selected_org?.id;

    const {
        isSuccess: successSK,
        isLoading: loadingSK,
        data: dataSK,
        refetch: refetchSK,
    } = useItemsFine(
        "qdb_social_keys",
        `filter[organization][_eq]=${selected_org}`,
        true
    );

    // Utility to extract platform key from msg

    useEffect(() => {
        if (status === "success" && msg) {
            refetchSK();
        } else if (status === "error" && msg) {
            message.error(msg);
        }
    }, [status, msg]);

    log.d(dataSK, "dataSK in soca");

    return (
        <QurealSection
            header={
                <SectionHeader
                    heading="Social Accounts"
                    icon={<ShareAltOutlined />}
                />
            }
        >
            <>
                <div
                    style={{
                        padding: isMobile ? "12px 8px" : "15px",
                    }}
                >
                    <div className={styles.wrapper}>
                        <InstagramConnector
                            dataMe={dataMe}
                            data={
                                successSK
                                    ? dataSK.filter(
                                          (item) =>
                                              item.platform === "Instagram"
                                      )
                                    : []
                            }
                            refetchSK={refetchSK}
                        />
                        <FacebookConnector dataMe={dataMe} />
                        <LinkedInConnector
                            dataMe={dataMe}
                            data={
                                successSK
                                    ? dataSK.filter(
                                          (item) => item.platform === "Linkedin"
                                      )
                                    : []
                            }
                            refetchSK={refetchSK}
                        />
                    </div>
                </div>
            </>
        </QurealSection>
    );
}

function getEncodedState(dataMe) {
    const selected_org = dataMe?.selected_org?.id;
    const user_id = dataMe?.id;
    const stateObj = {
        user_id: user_id,
        org_id: selected_org,
        return_url: window.location.href,
    };
    const stateStr = JSON.stringify(stateObj);
    return encodeURIComponent(stateStr);
}

function openInWindow(url) {
    // const newWindow = window.open(url, "_blank", "width=1000,height=800");
    // if (window.focus && newWindow) {
    //     newWindow.focus();
    // }
    window.location.href = url;
}

function SocialSectionWrapper({
    icon,
    name,
    children,
    onConnect,
    data,
    getCardInfo = () => {},
}) {
    const screens = useBreakpoint();
    const isMobile = !screens.sm;
    return (
        <div className={styles.section_wrapper}>
            <div className={styles.section_header}>
                <img src={icon} alt={name} className={styles.section_icon} />
                <span className={styles.section_name}>{name}</span>
                <Button
                    icon={<PlusOutlined />}
                    onClick={onConnect}
                    size={isMobile ? "large" : "middle"}
                >
                    Connect
                </Button>
            </div>
            {data && data?.length > 0 && (
                <div className={styles.cards_wrapper}>
                    {data?.map((item) => (
                        <SocialCard {...getCardInfo(item)} />
                    ))}
                </div>
            )}
        </div>
    );
}

function SocialCard({
    profile_pic,
    name,
    username,
    account_id,
    selected_org,
    link,
    onPost = () => {},
    onUnlink,
    loadingUnlink,
    expires_at,
}) {
    const screens = useBreakpoint();
    const isMobile = !screens.sm;
    const rawDays = expires_at
        ? Math.ceil((new Date(expires_at) - new Date()) / (1000 * 60 * 60 * 24))
        : null;

    return (
        <div
            className={styles.social_card}
            style={isMobile ? { width: "100%" } : {}}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                }}
            >
                <img src={profile_pic} alt={name} />
                <div className={styles.social_card_content}>
                    <p className={styles.name}>{name}</p>
                    <p className={styles.username}>{username}</p>
                    {rawDays !== null && rawDays > 0 && (
                        <p className={styles.subtext}>
                            {rawDays} day
                            {rawDays !== 1 ? "s" : ""} remaining
                        </p>
                    )}
                    {rawDays !== null && rawDays <= 0 && (
                        <p className={styles.overdue}>
                            Expired {Math.abs(rawDays)} day
                            {Math.abs(rawDays) !== 1 ? "s" : ""} ago
                        </p>
                    )}
                </div>
            </div>
            <div className={styles.action_panel}>
                {link && (
                    <Button
                        icon={<ExportOutlined />}
                        size={isMobile ? "large" : "middle"}
                        onClick={() => {
                            window.open(link, "_blank");
                        }}
                    ></Button>
                )}
                {onUnlink && (
                    <Button
                        icon={<DisconnectOutlined />}
                        size={isMobile ? "large" : "middle"}
                        onClick={onUnlink}
                        loading={loadingUnlink}
                    ></Button>
                )}
            </div>
        </div>
    );
}

function InstagramConnector({ dataMe, data, refetchSK }) {
    const mutationPost = usePostOnInstagram();

    const unlinkMutation = useDeleteItemMutation();
    const link = () => {
        let url = `https://www.instagram.com/oauth/authorize?force_reauth=false&client_id=1430244024776272&redirect_uri=https://botapi.qureal.com/social/instagram/callback&response_type=code&scope=instagram_business_basic,instagram_business_content_publish&state=${getEncodedState(
            dataMe
        )}`;

        openInWindow(url);
    };

    const postOnInsta = (account_id) => {
        const payload = {
            image_url:
                "https://images.unsplash.com/photo-1736000290462-71b8aaeb0ea6",
            caption: "Hello there from Qureal",
            account_id: `${account_id}`,
        };
        log.d(payload, "Payload");
        mutationPost.mutate(payload);
    };

    return (
        <SocialSectionWrapper
            icon="/images_rte/icons/instagram.png"
            name="Instagram"
            onConnect={link}
            data={data}
            getCardInfo={(item) => {
                return {
                    profile_pic: item?.profile_picture
                        ? getPublicImageURL(item?.profile_picture)
                        : null ||
                          item?.profile_info?.profile_picture_url ||
                          "/images_rte/icons/instagram.png",
                    name: item.profile_info?.name || "Instagram User",
                    account_id: item.account_id,
                    username: item.profile_info?.username || "@username",
                    link: `https://instagram.com/${item.profile_info?.username}`,
                    selected_org: dataMe?.selected_org?.id,
                    onPost: () => {
                        // alert("Posting...");
                        postOnInsta(item.profile_info?.instagram_user_id);
                    },
                    loadingUnlink: unlinkMutation.isLoading,
                    expires_at: item.expires_at,
                    onUnlink: () =>
                        unlinkMutation.mutate(
                            {
                                collection: "qdb_social_keys",
                                id: item.id,
                            },
                            {
                                onSuccess: () => {
                                    message.success(
                                        "Account unlinked successfully"
                                    );
                                },
                                onError: (error) => {
                                    message.error("Failed to unlink account");
                                    console.error("Update error:", error);
                                },
                            }
                        ), // unlink
                };
            }}
        />
    );
}

function FacebookConnector() {
    return (
        <SocialSectionWrapper
            icon="/images_rte/icons/facebook.png"
            name="Facebook"
        ></SocialSectionWrapper>
    );
}

function LinkedInConnector({ dataMe, data, refetchSK }) {
    const unlinkMutation = useDeleteItemMutation();
    const link = () => {
        const url = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=77c99lfcwqw0ih&redirect_uri=https://botapi.qureal.com/social/linkedin/callback&scope=openid%20profile%20email%20w_member_social&state=${getEncodedState(
            dataMe
        )}`;
        openInWindow(url);
    };
    return (
        <SocialSectionWrapper
            icon="/images_rte/icons/linkedin.png"
            name="LinkedIn"
            onConnect={link}
            data={data}
            getCardInfo={(item) => {
                return {
                    profile_pic:
                        item?.profile_info.picture ||
                        "/images_rte/icons/linkedin.png",
                    name: item.profile_info?.name || "LinkedIn User",
                    expires_at: item.expires_at,
                    onUnlink: () =>
                        unlinkMutation.mutate(
                            {
                                collection: "qdb_social_keys",
                                id: item.id,
                            },
                            {
                                onSuccess: () => {
                                    message.success(
                                        "Account unlinked successfully"
                                    );
                                },
                                onError: (error) => {
                                    message.error("Failed to unlink account");
                                    console.error("Update error:", error);
                                },
                            }
                        ), // unlink
                };
            }}
        />
    );
}
